import { render } from "./notificationPreviewDialog.vue?vue&type=template&id=501e40c0"
import script from "./notificationPreviewDialog.vue?vue&type=script&lang=js"
export * from "./notificationPreviewDialog.vue?vue&type=script&lang=js"

import "./notificationPreviewDialog.vue?vue&type=style&index=0&id=501e40c0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__